/**
 * Central Fonts Helper - All Available Fonts
 * This file contains all font options used across the application
 * for consistency and easy maintenance.
 */

// Title/Display Fonts - Bold, decorative fonts for headlines
export const titleFonts = [
    "Voyage", // ✅ NEUE FONT - Voyage als erstes hinzugefügt
    "Coolvetica", 
    "Mont", 
    "Garet", 
    "Tondu", 
    "Urbanist", 
    "Bloque", 
    "Classic", 
    "Gong", 
    "Voltaire", 
    "Vera", 
    "Dream", 
    "Rosehot", 
    "Belgiano", 
    "Arthead", 
    "Woody", 
    "Curvey", 
    "Posh", 
    "Boho", 
    "Money", 
    "Moonic", 
    "Buda", 
    "Valerie", 
    "Times", 
    "Tallboy",
    // ✅ ZUSÄTZLICHE FONTS aus Root-Ordner (nur CSS-definierte)
    "Dela",
    "Expansiva",
    "Gruppo",
    "Monty",
    "Pana",
    // Main Fonts - Alle aus Main Ordner
    "CanpileDrawn",
    "CSRecant",
    "D.Signature",
    "Figuea Granatae",
    "GC Vank",
    "Glory",
    "IMPULSE",
    "Misty Grey",
    "Prodigy",
    "Raymond Khomers Script",
    "Sabastein",
    "Sunday"
];

// Text/Body Fonts - Clean, readable fonts for body text
export const textFonts = [
    "Helvetica", 
    "Poppins", 
    "Roboto", 
    "Writer", 
    "Jost", 
    "Open Sans", 
    "Montserrat", 
    "Lato", 
    "Inter", 
    "Raleway", 
    "Nunito Sans", 
    "Arial", 
    "Caviar", 
    "Creato", 
    "Luis", 
    "Gontserrat",
    // Secondary Fonts - Alle aus Secondary Ordner
    "MPlus",
    "Bricolage",
    "Epilogue"
];

// All fonts combined (for general use)
export const allFonts = [...titleFonts, ...textFonts];

// Font categories with metadata
export const fontCategories = {
    title: {
        name: 'Title Fonts',
        description: 'Bold, decorative fonts perfect for headlines and titles',
        fonts: titleFonts
    },
    text: {
        name: 'Text Fonts', 
        description: 'Clean, readable fonts ideal for body text and paragraphs',
        fonts: textFonts
    }
};

// Default font selections
export const defaultFonts = {
    title: 'Voyage',
    text: 'Jost'
};

// Font utility functions
export const getFontsByCategory = (category) => {
    return fontCategories[category]?.fonts || [];
};

export const isValidFont = (fontName) => {
    return allFonts.includes(fontName);
};

export const getFontCategory = (fontName) => {
    if (titleFonts.includes(fontName)) return 'title';
    if (textFonts.includes(fontName)) return 'text';
    return null;
};

// Font preview text
export const fontPreviewText = {
    title: 'Aa Bb Cc',
    text: 'The quick brown fox'
};
